import React, { useEffect } from 'react';

import { useAppDispatch } from '../../hooks/redux';

import { useGetAppSettingsQuery } from '../../services/directus.api';
import { setSettings } from '../../store/appSettings.slice';

interface IAppSettingsProps {
  children: React.ReactNode;
}

const AppSettings: React.FC<IAppSettingsProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { data: settings, error, isLoading } = useGetAppSettingsQuery();

  useEffect(() => {
    if (settings) {
      dispatch(setSettings(settings));
    }
  }, [settings, dispatch]);

  if (isLoading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/60 rounded-[20px]">
        <span className="animate-spin border-2 border-t-transparent border-blackBase rounded-full w-8 h-8" />
      </div>
    );
  }

  if (error) {
    console.warn('Ошибка загрузки настроек', error);
  }

  return <>{children}</>;
};

export default AppSettings;
